import { Component } from '@angular/core';

@Component({
    selector: 'bb-notifications-page-ui',
    templateUrl: './bb-notifications-page-ui.component.html',
    standalone: false,
})
export class NotificationsPageComponent {}
